// extracted by mini-css-extract-plugin
module.exports = {"container":"CookiesPage_container__A4pVQ","text":"CookiesPage_text__H4Y9P","myCookies":"CookiesPage_myCookies__98pSV","pageHeader":"CookiesPage_pageHeader__enxuq"};